import { render, staticRenderFns } from "./DialogMenuPerimetro.vue?vue&type=template&id=52a01a15&scoped=true"
import script from "./DialogMenuPerimetro.vue?vue&type=script&lang=js"
export * from "./DialogMenuPerimetro.vue?vue&type=script&lang=js"
import style0 from "./DialogMenuPerimetro.vue?vue&type=style&index=0&id=52a01a15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a01a15",
  null
  
)

export default component.exports